import { NewOrderScenario } from "@/entities/new-order";

export const scenarioTitles = {
  [NewOrderScenario.create]: "Add campaign",
  [NewOrderScenario.duplicate]: "Duplicate campaign",
  [NewOrderScenario.extend]: "Extend campaign",
  [NewOrderScenario.promote]: "Promote campaign",
};